export default {"src":"/_next/static/media/heap.c2886324.svg","height":206,"width":537,"blurWidth":0,"blurHeight":0};